import { useNavigation } from '@react-navigation/native'
import { PostTypes } from 'constants/postTypes'
import React from 'react'

import { Box } from 'widgets/Box'
import { NoContent } from 'widgets/NoContent'
import { UpscoreBadge } from 'widgets/UpscoreBadge'

import { useCurrentUser } from 'hooks/useCurrentUser'
import { useNavigateBackOrHome } from 'hooks/useNavigateBackOrHome'
import { usePostCompletion } from 'hooks/usePostCompletion'

import { links } from 'utils/constants'
import { Toast } from 'utils/toast'

import { Post, StoredPostStep } from 'types/post'

import { FinalStepActions } from './FinalStepActions'
import { MediaPlayer } from './MediaPlayer'

import { StepContainer } from '../styled'
import { VideoProgress } from '../types'

export const PlayerContent = ({
  post,
  steps,
  currentSection,
  setProgress,
  handleRepeatPost,
  handleBack,
  showCompletePostPage,
}: {
  post: Post
  steps: StoredPostStep[]
  currentSection: number
  setProgress: (progress: number) => void
  handleRepeatPost: () => void
  handleBack: () => void
  showCompletePostPage: boolean
}) => {
  const navigate = useNavigateBackOrHome()
  const navigation = useNavigation()

  const { data: currentUser } = useCurrentUser()
  const { complete } = usePostCompletion(post)
  const { isLoading, data } = complete
  if (steps.length === 0) {
    return <NoContent />
  }

  const handleVideoProgress = (state: VideoProgress) => {
    setProgress(state.played * 100) // convert from decimal to percentage
  }

  const navigateToUpscorePage = () => {
    navigation.navigate(links.UPSCORE_PAGE, { userId: currentUser?.id })
  }

  const handleCompletePost = async () => {
    if (!currentUser?.id) {
      Toast.error(`Failed to complete post`, 'Missing data')
      return
    }

    complete.mutate({
      user: { id: currentUser.id },
      date: Date.now(),
    })

    if (!currentUser.dailyCompletions || currentUser.dailyCompletions < 4) {
      Toast.success(
        '',
        'You just completed a workout! Way to Go!\nPoints have been added to your Upscore.',
        undefined,
        {},
        true,
        'bottom',
        navigateToUpscorePage,
        'View',
        true,
        '',
        UpscoreBadge({ showOutline: false, text: '+1' }),
      )
    } else {
      Toast.success(
        'Way to Go!',
        'You just completed a workout!',
        undefined,
        undefined,
        true,
        'bottom',
        undefined,
        undefined,
        true,
      )
    }
    navigate()
  }
  const step = steps[currentSection]

  return (
    <Box flex={1} position='relative' backgroundColor='primary'>
      {showCompletePostPage && (
        <StepContainer>
          <FinalStepActions
            handleBack={handleBack}
            isWorkout={post.type === PostTypes.WORKOUT}
            isLastSection={showCompletePostPage}
            handleCompletePost={handleCompletePost}
            handleRepeatPost={handleRepeatPost}
            isLoading={isLoading}
            isCompleted={!!data}
          />
        </StepContainer>
      )}

      {!showCompletePostPage && (
        <MediaPlayer file={step.file} onVideoProgress={handleVideoProgress} isPreview={false} />
      )}
    </Box>
  )
}
